
// Keep as Enum for readability - 12/2023
// eslint-disable-next-line no-restricted-syntax
export enum ToastClassEnum {
  warning = 'is-warning',
  success = 'is-success',
  default = 'is-default'
}